import { supabase } from '../../shared/supabase/supabaseClient';
import { captureSentryError } from '../../shared/sentry/sentryUser';
export type PendingMpQrSaleSummary = {
  saleId: string;
  total: number;
  pendingAmount: number;
  fiscalMode: 'fiscal' | 'non_fiscal';
};

const PENDING_MP_QR_LOOKBACK_DAYS = 7;

function isExpectedPendingMpQrAccessDenied(error: { code?: string; message?: string }): boolean {
  const code = String(error.code ?? '').trim();
  const msg = String(error.message ?? '').toLowerCase();
  return code === '42501' || msg.includes('forbidden');
}

async function listPendingMpQrSalesRemote(
  branchId: string,
  limit: number
): Promise<PendingMpQrSaleSummary[]> {
  try {
    const { data, error } = await supabase.schema('pos').rpc('list_pending_mp_qr_sales', {
      p_branch_id: branchId,
      p_limit: limit,
      p_lookback_days: PENDING_MP_QR_LOOKBACK_DAYS,
    });

    if (error) {
      if (!isExpectedPendingMpQrAccessDenied(error)) {
        captureSentryError(error, { tags: { module: 'mercadopago', op: 'mp.pending_qr_sales' } });
      }
      return [];
    }
    if (!Array.isArray(data)) return [];

    return data.map((row) => ({
      saleId: String(row.sale_id),
      total: Number(row.total ?? 0),
      pendingAmount: Number(row.pending_amount ?? row.total ?? 0),
      fiscalMode: row.fiscal_mode === 'non_fiscal' ? 'non_fiscal' : 'fiscal',
    }));
  } catch (e) {
    captureSentryError(e, { tags: { module: 'mercadopago', op: 'mp.pending_qr_sales' } });
    return [];
  }
}

export async function listPendingMpQrSalesForBranch(
  branchId: string,
  limit = 10
): Promise<PendingMpQrSaleSummary[]> {
  const safeLimit = Math.min(Math.max(limit, 1), 20);

  return listPendingMpQrSalesRemote(branchId, safeLimit);
}
